import { render, staticRenderFns } from "./TyreGrid.vue?vue&type=template&id=37a20204&scoped=true&"
import script from "./TyreGrid.vue?vue&type=script&lang=js&"
export * from "./TyreGrid.vue?vue&type=script&lang=js&"
import style0 from "./TyreGrid.vue?vue&type=style&index=0&id=37a20204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a20204",
  null
  
)

export default component.exports